"use client";

import { useSearchParams } from "next/navigation";
import { hirlevelFeliratkozas } from "@/lib/actions/hirlevel";

export function HirlevelFeliratkozas({ visszaOldal = "/ajanlatkeres" }: { visszaOldal?: string }) {
  const params = useSearchParams();
  const siker = params.get("hirlevel_siker");
  const hiba = params.get("hirlevel_hiba");

  if (siker) {
    return <p style={{ color: "var(--fkm-green-dim)", fontWeight: 600 }}>Köszönjük a feliratkozást!</p>;
  }

  return (
    <form
      id="hirlevel"
      action={hirlevelFeliratkozas}
      style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", alignItems: "center" }}
    >
      <input type="hidden" name="vissza_oldal" value={visszaOldal} />
      {hiba && <p className="form-msg error" style={{ width: "100%" }}>Kérjük, adjon meg egy e-mail címet.</p>}
      <input
        name="email"
        type="email"
        placeholder="E-mail cím"
        required
        style={{
          minHeight: "44px",
          padding: "0 0.85rem",
          border: "1px solid var(--fkm-line)",
          borderRadius: "10px",
          fontFamily: "var(--font-body)",
        }}
      />
      <button type="submit" className="btn btn-primary">
        Feliratkozom
      </button>
    </form>
  );
}
